import _ from 'lodash';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromP2P from './p2p.reducer';

export const selectP2PState = createFeatureSelector<fromP2P.State>(
  fromP2P.p2pFeatureKey
);

export const selectP2PCampaignsList = createSelector(
  selectP2PState,
  (state: fromP2P.State) => {
    return state.P2PCampaigns;
  }
);

export const selectSelectedP2PCampaign = createSelector(
  selectP2PState,
  (state: fromP2P.State) => {
    return state.SelectedP2PCampaign;
  }
);

export const selectFundraiserReport = createSelector(
  selectP2PState,
  (state: fromP2P.State) => {
    return state.P2PFundraiserReport;
  }
);

export const selectP2PDonations = createSelector(
  selectP2PState,
  (state: fromP2P.State) => {
    return state.P2PDonations;
  }
);

export const selectAddP2PDonation = createSelector(
  selectP2PState,
  (state: fromP2P.State) => {
    return state.P2PDonations;
  }
);

export const selectModalDonations = createSelector(
  selectP2PState,
  (state: fromP2P.State) => {
    return state.transactions;
  }
);

export const selectModalPledges = createSelector(
  selectP2PState,
  (state: fromP2P.State) => {
    return state.pledges;
  }
);